'use client'

import React from 'react'

import type {CaptchaRenderProps} from '@/src/features/auth/core/login-types'
import {FormTemplate} from '@/src/shared/modules/form'

import {InvisibleCaptcha} from '@/src/shared/modules/captcha'
import Button from '@/src/shared/ui/button'
import {AsyncProcessLoading} from '@/src/shared/ui/layout/ui/async-loading'

import {Container, StyledPhoneInput, LoginButton} from './login.styled'
import styled from 'styled-components'

type LoginFormProps = {
  loading: boolean
  isTokenReady: boolean
  onSubmit: () => void
  captchaProps: CaptchaRenderProps
  providers?: React.ReactNode
}

export const LoginForm = ({loading, isTokenReady, onSubmit, captchaProps, providers}: LoginFormProps) => {
  return (
    <>
      <FormTemplateStyled title="Введите телефон" data-testid="login-form">
        {loading && <AsyncProcessLoading />}
        <Container>
          <InvisibleCaptcha {...captchaProps} key={captchaProps.renderKey} />

          <StyledPhoneInput
            required
            name="phone"
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                onSubmit()
              }
            }}>
            Номер телефона
          </StyledPhoneInput>

          <LoginButton
            as={Button}
            data-testid="send-otp-btn"
            type="submit"
            onClick={onSubmit}
            disabled={!isTokenReady}
            loading={!isTokenReady}>
            Войти
          </LoginButton>

          {providers}
        </Container>
      </FormTemplateStyled>
    </>
  )
}

const FormTemplateStyled = styled(FormTemplate)`
    & ${FormTemplate.__UI.Form} {
      max-width: 465px;
    }
`